'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useMemo, type JSX } from 'react';
import { Tweet } from 'react-tweet';
import Button from '@/components/atoms/Button';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import ArrowLeft from '@/public/assets/svg/pager-left.svg';
import ArrowRight from '@/public/assets/svg/pager-right.svg';
import XLogo from '@/public/assets/svg/X_logo.svg';
import TweetBoundary from './partials/TweetBoundary';

/**
 * Props for `TwitterList`.
 */
export type TwitterListProps = SliceComponentProps<Content.TwitterListSlice>;

/**
 * Component for "TwitterList" Slices.
 */
const TwitterList = t0 => {
  const $ = _c(27);
  const {
    slice
  } = t0;
  const isDesktop = useIsDesktop();
  let t1;
  bb0: {
    if (isDesktop) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = [Autoplay({
        delay: 4000,
        stopOnInteraction: false
      })];
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    t1 = t2;
  }
  const additionalFeatures = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      loop: true,
      align: "start"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2, additionalFeatures);
  let t3;
  if ($[3] !== emblaApi) {
    t3 = () => {
      if (emblaApi) {
        emblaApi.scrollPrev();
      }
    };
    $[3] = emblaApi;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const scrollPrev = t3;
  let t4;
  if ($[5] !== emblaApi) {
    t4 = () => {
      if (emblaApi) {
        emblaApi.scrollNext();
      }
    };
    $[5] = emblaApi;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const scrollNext = t4;
  const t5 = slice.slice_type;
  const t6 = slice.variation;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="hidden w-25 lg:block" />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h3 className="text-h3 lg:text-title flex items-center gap-x-2.5 font-bold lg:gap-x-4">Featured From <XLogo className="scale-75 lg:scale-100" data-sentry-element="XLogo" data-sentry-source-file="index.tsx" /></h3>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== scrollNext || $[10] !== scrollPrev || $[11] !== slice.items.length) {
    t9 = slice.items.length > 3 && <><Button onClick={scrollPrev} className="w-11 p-0!" variant="light-outline"><ArrowLeft className="h-6 w-6" /></Button><Button onClick={scrollNext} className="w-11 p-0!" variant="light-outline"><ArrowRight className="h-6 w-6" /></Button></>;
    $[9] = scrollNext;
    $[10] = scrollPrev;
    $[11] = slice.items.length;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <div className="mb-15 flex w-full justify-center lg:justify-between">{t7}{t8}<div className="hidden w-25 gap-x-3 lg:flex">{t9}</div></div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== slice.items) {
    t11 = slice.items.map(_temp);
    $[15] = slice.items;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <div data-theme="light" className="auto-cols-full md:auto-cols-half lg:auto-cols-third grid w-full grid-flow-col">{t11}</div>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== emblaRef || $[20] !== t12) {
    t13 = <div className="relative"><div className="overflow-hidden" ref={emblaRef}>{t12}</div></div>;
    $[19] = emblaRef;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== slice.slice_type || $[23] !== slice.variation || $[24] !== t10 || $[25] !== t13) {
    t14 = <section className="o-container o-container--xl my-44 px-0" data-slice-type={t5} data-slice-variation={t6} data-sentry-component="TwitterList" data-sentry-source-file="index.tsx">{t10}{t13}</section>;
    $[22] = slice.slice_type;
    $[23] = slice.variation;
    $[24] = t10;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
};
export default TwitterList;
function _temp(item) {
  return <div className="px-2.5" key={item.tweet_id}><TweetBoundary tweetId={item.tweet_id as string}><Tweet id={item.tweet_id as string} /></TweetBoundary></div>;
}